import React from 'react'
import { RecoilRoot } from 'recoil'
import { config } from '@fortawesome/fontawesome-svg-core'

import "@fortawesome/fontawesome-svg-core/styles.css"
import './src/index.scss'

config.autoAddCss = false
export const wrapRootElement = ({ element }) => {
  return (
    <RecoilRoot>
      {element}
    </RecoilRoot>
  )
}

/*export const onPreRouteUpdate = ({ location, prevLocation }) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'onPreRouteUpdate',
    fromLocation: location.pathname,
    toLocation: prevLocation ? prevLocation.pathname : null
  })
}*/

// Account Engagement (Pardot) only tracks the initial page load, so report
// client-side route changes. piTracker is only defined once pd.js has loaded,
// which in turn only happens with Targeting (C0004) consent (see gatsby-ssr.js).
export const onRouteUpdate = ({ location, prevLocation }) => {
  if (!prevLocation || typeof window.piTracker !== 'function') {
    return
  }

  if (typeof window.hasConsent === 'function' && !window.hasConsent('C0004')) {
    return
  }

  window.piTracker(location.href)
}
